import React from 'react';
import { useTranslation } from 'react-i18next';

import { General } from 'icons/untitledui';
import * as DropdownStyled from 'theme/components/Dropdown.style';
import * as SelectionStyled from 'theme/components/SelectionDropdown.style';
import * as Styled from '../../styles/FilterGroupingControl.style';
import { SignalOption } from './_types';

interface SignalFilterMenuProps {
  signals: SignalOption[];
  selected: string | null;
  onSelect: (id: string | null) => void;
  topOffset?: number;
}

export default function SignalFilterMenu({
  signals,
  selected,
  onSelect,
  topOffset,
}: SignalFilterMenuProps): JSX.Element {
  const { t } = useTranslation('pageEvents');

  return (
    <Styled.PopoverCard $zIndex={1400} $topOffset={topOffset} $leftOffset={-40}>
      <Styled.List>
        <DropdownStyled.SectionHeader>
          {t('filterGrouping.signal.title')}
        </DropdownStyled.SectionHeader>
        {signals.map((signal) => {
          const isSelected = selected === signal.id;
          return (
            <SelectionStyled.Option
              key={signal.id}
              type="button"
              $selected={isSelected}
              onClick={() => onSelect(isSelected ? null : signal.id)}
              role="menuitemradio"
              aria-checked={isSelected}
            >
              <span>{signal.name}</span>
              <SelectionStyled.OptionCheck $selected={isSelected}>
                {isSelected && <General.Check size={16} />}
              </SelectionStyled.OptionCheck>
            </SelectionStyled.Option>
          );
        })}
      </Styled.List>
    </Styled.PopoverCard>
  );
}
